// src/components/ErrorBoundary/ErrorRecoveryComponent.tsx

import React, { ErrorInfo } from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

interface ErrorRecoveryComponentProps {
    error: Error | null;
    errorInfo: ErrorInfo | null;
    onReset: () => void;
}

const ErrorRecoveryComponent: React.FC<ErrorRecoveryComponentProps> = ({ error, errorInfo, onReset }) => {
    return (
        /* .error-recovery-container:
           flex flex-col items-center justify-center min-h-[400px] p-8 text-center
           bg-[#f8f9fa] dark:bg-[#1e293b] rounded-lg m-4 */
        <div
            className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-[#f8f9fa] dark:bg-[#1e293b] rounded-lg m-4"
            role="alert"
        >
            {/* .error-content: max-w-[500px] */}
            <div className="max-w-[500px]">
                {/* .error-icon: text-[#d93025] mb-4 */}
                <AlertTriangle size={48} className="text-[#d93025] mb-4" />

                {/* .error-content h2: text-2xl font-semibold mb-2 text-[#202124] dark:text-[#f8fafc] */}
                <h2 className="text-2xl font-semibold mb-2 text-[#202124] dark:text-[#f8fafc]">Something went wrong</h2>

                {/* .error-content p: text-[#4c5054] dark:text-[#94a3b8] mb-6 */}
                <p className="text-[#4c5054] dark:text-[#94a3b8] mb-6">We apologize for the inconvenience. Please try again.</p>

                {import.meta.env.MODE === 'development' && (
                    /* .error-details: my-4 p-4 bg-[#ffffff] dark:bg-[#0f172a] rounded-md text-left */
                    <details className="my-4 p-4 bg-[#ffffff] dark:bg-[#0f172a] rounded-md text-left">
                        {/* .error-details summary: cursor-pointer text-[#4c5054] dark:text-[#94a3b8] mb-2 */}
                        <summary className="cursor-pointer text-[#4c5054] dark:text-[#94a3b8] mb-2">Error Details</summary>
                        {/* .error-details pre: text-sm whitespace-pre-wrap break-all text-[#d93025] mt-2 */}
                        <pre className="text-sm whitespace-pre-wrap break-all text-[#d93025] mt-2">{error?.toString()}</pre>
                        <pre className="text-sm whitespace-pre-wrap break-all text-[#d93025] mt-2">{errorInfo?.componentStack}</pre>
                    </details>
                )}

                {/* .reset-button:
                    inline-flex items-center gap-2 py-3 px-6 bg-[#1a73e8] text-white border-0
                    rounded-md font-medium cursor-pointer transition-all duration-200
                    hover:bg-[#1557b0] */}
                <button
                    className="inline-flex items-center gap-2 py-3 px-6 bg-[#1a73e8] text-white border-0 rounded-md font-medium cursor-pointer transition-all duration-200 hover:bg-[#1557b0]"
                    onClick={onReset}
                    aria-label="Try again"
                >
                    <RefreshCw size={16} />
                    Try Again
                </button>
            </div>
        </div>
    );
};

export default ErrorRecoveryComponent;
